<template>
  <b-button :type="type" variant="primary" class="btn btn-success" :disabled="disabled || loading" @click="$emit('click')">
    <div class="d-flex align-items-center">
      <b-spinner v-if="loading" small class="mr-1" />
      <span v-else class="icon-check mr-1"></span> {{ text || $t('saveChanges') }}
    </div>
  </b-button>
</template>

<script>
export default{
  props:{
    type: {
      type: String,
      default: null
    },
    text: {
      type: String
    },
    disabled:{
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>